import { render, staticRenderFns } from "./settings-expand.vue?vue&type=template&id=1c6f8f5c&scoped=true&"
import script from "./settings-expand.vue?vue&type=script&lang=js&"
export * from "./settings-expand.vue?vue&type=script&lang=js&"
import style0 from "./settings-expand.vue?vue&type=style&index=0&id=1c6f8f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f8f5c",
  null
  
)

export default component.exports